<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__appsysenum}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.materialId" placeholder="素材id" clearable></el-input>
          
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataForm.advertiserId" placeholder="广告账户Id" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item>
          <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getTimes">
          </el-date-picker>
        </el-form-item> -->
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
  <!--        <el-form-item>-->
  <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
  <!--        </el-form-item>-->
          <el-form-item>
           
            <el-button v-if="$hasPermission('sys:videomedia:syncMedia')" type="primary" @click="()=>{$router.push({
              path:'sys-videouploadinfo'
            })}">继续同步</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('sys:appsysenum:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
          <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
          <el-table-column prop="materialId" label="素材id" header-align="center" align="center"></el-table-column>
          <el-table-column prop="fullName" label="视频名称" header-align="center" align="center">
  
          </el-table-column>
          <el-table-column  prop="projectName" label="项目" header-align="center" align="center">
              
          </el-table-column>

          <el-table-column prop="detailName" label="明细" header-align="center" align="center"></el-table-column>
          <el-table-column prop="" label="md5" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="typeName" label="视频种类" header-align="center" align="center">
            
          </el-table-column>
         <el-table-column prop="" label="预览" header-align="center" align="center">
          <template slot-scope="scope">
            <videoPlay :src="scope.row.videoUrl"></videoPlay>
            </template>
         </el-table-column>
         <el-table-column prop="syncDate" label="同步日期" header-align="center" align="center"></el-table-column>
         <el-table-column prop="advertiserId" label="广告账户Id" header-align="center" align="center"></el-table-column>
         
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './videomedia-add-or-update.vue'
  import videoPlay from '../../../components/video-play.vue'
  export default {
    mixins: [mixinViewModule],
   
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/videomedia/page',
          getDataListIsPage: true,
          exportURL: '/sys/videomedia/export',
          deleteURL: '/sys/videomedia',
          deleteIsBatch: true
        },
        date:'',
        dataForm: {
          sourceVideoId:'',
          advertiserId:'',
          startDate:'',
          endDate:'',
        }
      }
    },
   
      
    methods:{
       open(text) {
          this.$alert(text, '内容',{
            lockScroll:false,
            confirmButtonText: '确定',
            // callback: action => {
            //   // this.$message({
            //   //   type: 'info',
            //   //   message: `action: ${ action }`
            //   // });
            // }
          });
         
        },
        getTimes() {
          if (this.date != null) {
            this.dataForm.startDate = this.date[0]
            this.dataForm.endDate = this.date[1]
          }else{
            this.dataForm.startDate =''
            this.dataForm.endDate = ''
          }
        }
    },
    components: {
      AddOrUpdate,
      videoPlay
    }
  }
  </script>
  
  <style>
  .value-box{
    position: relative;
  }
    .value{
      overflow:hidden;
      text-overflow:ellipsis; 
      white-space:nowrap 
    }
   
    .hoverValue{
      position: absolute;
      width: 200px;
      height: 300px;
      top: 0;
      left: 10px;
      background: white;
      border: 1px solid black;
      overflow: auto;
      display: none;
      z-index: 999;
    }
  
 
  </style>
  
  